import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['users'] as const;

export const usersQueryKeys = {
  base: baseKey,
  getUser: [...baseKey, 'getUser'],
  getUsers: [...baseKey, 'getUsers'],
  createUser: [...baseKey, 'create'],
  updateUser: [...baseKey, 'update'],
  updateUserLicense: [...baseKey, 'updateLicense'],
} as const;
